<div
  class="scaffold-table-holder"
  [ngClass]="{ 'contrast-table': item?.use_contrast_background }"
>
  <div
    class="top-row-controls-container"
    *ngIf="!item.avoid_paginating || item.allow_search"
  >
    <scaffold-search-bar
      *ngIf="item.allow_search"
      [forceOnlyActive]="item?.force_only_active_items"
      [displayActiveStateFilter]="item?.display_active_state_filter"
      [allowSearch]="item.allow_search"
      [hideTermSelect]="item.hide_terms"
      (search)="search($event)"
      [searchData]="searchTerms"
    >
    </scaffold-search-bar>

    <scaffold-paginate-page-select
      *ngIf="!item?.avoid_paginating"
      (perPageChange)="setPageCount($event)"
      [perPageOptions]="item?.pageCounts"
      [(perPage)]="perPage"
      [countLabel]="getCountLabel()"
    ></scaffold-paginate-page-select>
  </div>
  <div class="loading-table-wrapper">
    <div class="loading-table-overlay-spinner-container" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
    </div>
    <div [ngClass]="{ 'loading-table-overlay': isLoading }">
      <ng-container *ngIf="itemCount == 0; else mainview"
        ><div class="no-table-result-container" *ngIf="!isLoading">
          <label *ngIf="item"
            >{{'no'|translation|translationFromString | transformText :'capitalize'}} {{ item?.list_view || "data" | translation|titlecase }} {{'to_display'|translation| transformText :'capitalize'}}</label
          >
        </div>
      </ng-container>
      <ng-template #mainview>
        <div *ngIf="item.data_source === 'list'">
          <scaffold-toggle-slide
            status="info"
            [(ngModel)]="item.showTotals"
            *ngIf="item.allow_counts"
          >
            {{ "show_column_totals"| translation }}
          </scaffold-toggle-slide>

          <table
            [nbTreeGrid]="view"
            style="width: 100%"
            [equalColumnsWidth]="false"
            [attr.aria-label]="data - table"
          >
            <ng-container nbTreeGridColumnDef="Delete">
              <th
                nbTreeGridHeaderCell
                *nbTreeGridHeaderCellDef
                style="width: 100px"
              ></th>
              <td nbTreeGridCell *nbTreeGridCellDef="let element">
                <button
                  nbButton
                  ghost
                  (click)="editItem(element.data, $event)"
                  *ngIf="item.allow_edit"
                  [title]="'edit'| translation"
                  status="info"
                >
                  <nb-icon pack="fas" icon="pencil-alt"> </nb-icon>
                </button>
                <button
                  nbButton
                  ghost
                  (click)="deleteItem($event, element.data)"
                  *ngIf="item.allow_delete"
                  [title]="'delete'| translation"
                  status="info"
                >
                  <nb-icon pack="fas" icon="trash-alt"> </nb-icon>
                </button>
              </td>
            </ng-container>
            <ng-container
              [nbTreeGridColumnDef]="col.label"
              *ngFor="let col of columnData"
            >
              <th
                nbTreeGridHeaderCell
                *nbTreeGridHeaderCellDef
                [style.cursor]="getCursor(col.data)"
                title="{{'sort_by'| translation}} {{ col.label |translation}}"
                (click)="sortTable(col.data)"
              >
                <span> {{ col.translation_key || col.label| translation |translationFromString | transformText :col?.text_transform}}</span>
                <span
                  *ngIf="tableSortData.param !== col.data"
                  class="fa-solid fa-caret-down"
                  style="padding-left: 8px"
                  [style]="
                    getCursor(col.data) === 'unset' ? 'visibility:hidden' : ''
                  "
                >
                </span>
                <span
                  style="padding-left: 8px"
                  *ngIf="tableSortData.param === col.data"
                >
                  <i
                    class="fas text-link-color"
                    [ngClass]="{
                      'fa-caret-down': tableSortData.direction > 0,
                      'fa-caret-up': tableSortData.direction < 0
                    }"
                  >
                  </i>
                </span>
                <br />
                <span *ngIf="item.allow_counts && item.showTotals">
                  <span
                    *ngFor="let total of totals[col.label]"
                    style="font-size: 0.8em"
                  >
                    <span *ngIf="total">
                      {{ total.value }}: {{ total.count }}
                    </span>
                    <br />
                  </span>
                </span>
              </th>
              <td nbTreeGridCell *nbTreeGridCellDef="let element">
                <div
                  [ngClass]="{
                    'data-table-td-content-grey':
                      !element.data?.[col?.data] &&
                      col?.default_value &&
                      col?.default_value_style_grey,
                    'data-table-td-content-italic':
                      !element.data?.[col?.data] &&
                      col?.default_value &&
                      col?.default_value_style_italic
                  }"
                  *ngIf="!col.link"
                  [innerHTML]="
                    getData(element?.data?.[col?.data], col?.type, col, element)|translation
                      |translationFromString| safeHtml
                  "
                ></div>
                <div *ngIf="col.link">
                  <a
                    (click)="openLink($event, element?.data, activatedRoute)"
                    [href]="getURL(element?.data) | safe"
                    [innerHTML]="
                      getData(element.data?.[col?.data], col.type, col)|translation|translationFromString | safeHtml
                    "
                  >
                  </a>
                </div>
              </td>
            </ng-container>
            <tr
              [clickToToggle]="false"
              nbTreeGridHeaderRow
              *nbTreeGridHeaderRowDef="filterColumns()"
            ></tr>
            <tr
              [ngClass]="{
                'data-table--link-row': !!item?.row_link,
                'data-table--uppercase': item?.rowTextTransform === 'uppercase',
                'data-table--capitalize':
                  item?.rowTextTransform === 'capitalize'
              }"
              [clickToToggle]="false"
              nbTreeGridRow
              *nbTreeGridRowDef="let row; columns: filterColumns()"
              (copy)="handleCopy($event)"
              (click)="openLinkRow($event, row?.data)"
            ></tr>
          </table>

          <p *ngIf="item.search_load && !view?.length" style="padding: 0 20px">
            {{ "items_no_search_made_yet"| translation }}.
          </p>
          <div>
            <scaffold-paginator
              *ngIf="!item?.avoid_paginating"
              [itemCount]="itemCount"
              [(activePage)]="active"
              [perPage]="perPage"
            >
            </scaffold-paginator>
          </div>
        </div>
        <div *ngIf="item.data_source !== 'list'">
          <table
            [nbTreeGrid]="table_value"
            style="width: 100%"
            [attr.aria-label]="data - table"
          >
            <ng-container nbTreeGridColumnDef="Delete">
              <th
                nbTreeGridHeaderCell
                *nbTreeGridHeaderCellDef
                style="width: 100px"
              >
                {{ "delete"| translation }}
              </th>
              <td nbTreeGridCell *nbTreeGridCellDef="let element">
                <button
                  nbButton
                  ghost
                  (click)="deleteRow(element, table_value)"
                  status="info"
                  [title]="'delete'| translation"
                >
                  <nb-icon pack="fas" icon="trash-alt"> </nb-icon>
                </button>
              </td>
            </ng-container>
            <ng-container
              [nbTreeGridColumnDef]="col.label"
              *ngFor="let col of columnData"
            >
              <th
                nbTreeGridHeaderCell
                *nbTreeGridHeaderCellDef
                (click)="sortTable(col.data)"
                style="cursor: pointer"
                title="{{'sort_by'| translation}} {{ col.label }}"
              >
                {{ col.translation_key || col.label| translation|translationFromString | transformText :col?.text_transform }}
                <span
                  *ngIf="tableSortData.param !== col.data"
                  class="fas fa-caret-down"
                  style="visibility: hidden"
                >
                </span>
                <span *ngIf="tableSortData.param === col.data">
                  <i
                    class="fas"
                    [ngClass]="{
                      'fa-caret-down': tableSortData.direction > 0,
                      'fa-caret-up': tableSortData.direction < 0
                    }"
                  >
                  </i>
                </span>
              </th>
              <td nbTreeGridCell *nbTreeGridCellDef="let element">
                <div [ngSwitch]="col.input_type">
                  <input
                    *ngSwitchCase="'text'"
                    [(ngModel)]="element[col.data]"
                    (input)="editTableValue($event, element, col)"
                    type="text"
                    style="width: 100%; border: none"
                    [disabled]="checkDisable()"
                  />
                  <input
                    *ngSwitchCase="'number'"
                    [(ngModel)]="element[col.data]"
                    (input)="editTableValue($event, element, col)"
                    type="number"
                    style="width: 100%; border: none"
                    [disabled]="checkDisable()"
                  />
                  <nb-form-field
                    *ngSwitchCase="'select'"
                    style="width: 100%; border: none"
                  >
                    <nb-select
                      [(ngModel)]="element[col.data]"
                      [placeholder]="item.translation_key ||item.label| translation|translationFromString | transformText :item?.text_transform"
                      (selectedChange)="editTableValue($event, element, col)"
                      [disabled]="checkDisable()"
                    >
                      <nb-option
                        *ngFor="let option of col.options"
                        [value]="option.value"
                      >
                      {{ option.translation_key|| option.label| translation |translationFromString | transformText :option?.text_transform}}
                      </nb-option>
                    </nb-select>
                  </nb-form-field>
                  <div *ngSwitchCase="'none'">
                    {{ element[col.data] }}
                  </div>
                  <div *ngSwitchDefault>
                    {{ element[col.data] }}
                  </div>
                </div>
              </td>
            </ng-container>
            <tr nbTreeGridHeaderRow *nbTreeGridHeaderRowDef="columns"></tr>
            <tr
              nbTreeGridRow
              [clickToToggle]="false"
              *nbTreeGridRowDef="let row; columns: columns"
            ></tr>
          </table>
          <p *ngIf="item.search_load" style="padding: 0 20px">
            {{'items_no_search_made_yet'| translation}}.
          </p>
          <div>
            <scaffold-paginator
              *ngIf="!item?.avoid_paginating"
              [itemCount]="itemCount"
              [(activePage)]="active"
              [perPage]="perPage"
            >
            </scaffold-paginator>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
